export default "__VITE_IMAGE_ASSET__dff8074e__";